import { render, staticRenderFns } from "./TeamPlanSignup.vue?vue&type=template&id=634bfd49&scoped=true"
import script from "./TeamPlanSignup.vue?vue&type=script&lang=ts"
export * from "./TeamPlanSignup.vue?vue&type=script&lang=ts"
import style0 from "./TeamPlanSignup.vue?vue&type=style&index=0&id=634bfd49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634bfd49",
  null
  
)

export default component.exports